import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { slideInOutAnimation } from 'src/app/route-animations';
import { ValuationService } from 'src/app/services/valuation.service';
import { SHARED_IMPORTS } from '../../shared/standalone-imports';

@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  styleUrls: ['./verification-code.component.scss'],
  animations: [slideInOutAnimation],
  host: { '[@slideInOutAnimation]': '' },
  standalone: true,
  imports: [...SHARED_IMPORTS],
})
export class VerificationCodeComponent implements OnInit {
  public codeSend = false;
  public newCodeSend = false;
  public codeIncorrect = false;
  public hasClickedDecline = false;
  public codeResponse: any;
  public verificationForm: UntypedFormGroup;

  constructor(
    public fb: UntypedFormBuilder,
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly ngxService: NgxUiLoaderService,
    private readonly route: ActivatedRoute,
    private readonly valuationService: ValuationService,
  ) {

    const routeStatus = this.route.snapshot.paramMap.get('action');
    // We can pass statusses from other pages and display messages based on type.
    if (routeStatus != null) {
      switch (routeStatus) {
        case 'clicked_decline':
          this.hasClickedDecline = true;
          break;
      }
    }

    this.verificationForm = fb.group({
      code: [null, Validators.required],
    });
  }

  public ngOnInit(): void {
    this.ngxService.start();
    // Get route params used in servcie
    this.route.params.subscribe((routeParams) => {
      // Sync data
      this.valuationService.syncValuationData(routeParams).then(data => {
        // Check if verified has been set.
      }, error => {
        console.error(error);
      })
    });
  }

  public sendCode() {
    this.ngxService.start();
    this.codeSend = true;
    this.authService.requestVerificationCode().subscribe(data => {
      this.codeResponse = data
      this.ngxService.stopAll();
    })
  }

  public sendNewCode() {
    this.ngxService.start();
    this.codeSend = true;
    this.authService.requestVerificationCode().subscribe(data => {
      this.newCodeSend = true;
      this.codeResponse = data
      this.ngxService.stopAll();
    })
  }

  public checkCode() {
    this.ngxService.start();
    this.authService.checkVerificationCode({ code: this.verificationForm.controls['code'].value }).subscribe(data => {
      if (data.error == false) {
        this.ngxService.stop();
        this.codeIncorrect = false;
        localStorage.setItem('verified', String(new Date().getTime()));
        if (localStorage.getItem('state') == null) {
          this.router.navigate(['/informatie-aanleveren']);
        } else {
          if (localStorage.getItem('state') == '/verificatie') {
            this.router.navigate(['/informatie-aanleveren']);
          } else {
            this.router.navigate(['/' + localStorage.getItem('state')]);
          }
        }
      } else {
        this.ngxService.stop();
        this.codeIncorrect = true;
      }
    })
  }
}
